// frontend/src/utils/safeStorage.ts
// Safe localStorage wrapper — prevents crashes from quota exceeded,
// Safari private mode, or corrupted storage.
// Replace direct localStorage.* calls with these wrappers.

const STORAGE_UNAVAILABLE = 'localStorage is not available';

function isAvailable(): boolean {
  try {
    const test = '__storage_test__';
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch {
    return false;
  }
}

export function safeGetItem(key: string, fallback: string | null = null): string | null {
  try {
    if (!isAvailable()) return fallback;
    return localStorage.getItem(key);
  } catch {
    return fallback;
  }
}

export function safeSetItem(key: string, value: string): boolean {
  try {
    if (!isAvailable()) return false;
    localStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

export function safeRemoveItem(key: string): boolean {
  try {
    if (!isAvailable()) return false;
    localStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}

export function safeGetJSON<T>(key: string, fallback: T): T {
  try {
    const raw = safeGetItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

export function safeSetJSON(key: string, value: unknown): boolean {
  try {
    return safeSetItem(key, JSON.stringify(value));
  } catch {
    return false;
  }
}